/**
 * Utilitários para conversão de datas de nascimento
 */

/**
 * Converte data de nascimento de DD/MM/YYYY para YYYY-MM-DD
 * Formato usado pelos gateways de pagamento
 */
export const convertBirthDateToISO = (birthDate: string): string => {
  if (!birthDate || birthDate.length !== 10) return '';
  const [day, month, year] = birthDate.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

/**
 * Converte data de nascimento de YYYY-MM-DD para DD/MM/YYYY
 * Formato usado pela interface do usuário
 */
export const convertISOToBirthDate = (isoDate: string): string => {
  if (!isoDate || isoDate.length !== 10) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};
